import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";

const base = "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-[15px] font-semibold transition-[background-color,color,border-color,transform,box-shadow] duration-200 active:scale-[0.98]";

const styles = {
  light: "bg-white text-slate-950 hover:bg-cyan-50 hover:shadow-[0_8px_30px_-8px_rgba(34,211,238,0.55)]",
  dark: "bg-slate-950 text-white hover:bg-slate-800",
  ghostDark: "border border-white/20 text-white hover:border-white/50 hover:bg-white/5",
  ghostLight: "border border-slate-300 text-slate-900 hover:border-slate-900",
};

const Inner = ({ children, arrow }) => (
  <>
    {children}
    {arrow === "up" ? (
      <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    ) : arrow ? (
      <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
    ) : null}
  </>
);

export const CtaLink = ({ to, href, variant = "light", arrow = "up", children, className = "", ...rest }) => {
  const cls = `${base} ${styles[variant]} ${className}`;
  if (href) {
    const ext = href.startsWith("http");
    return (
      <a href={href} className={cls} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
        <Inner arrow={arrow}>{children}</Inner>
      </a>
    );
  }
  return (
    <Link to={to} className={cls} {...rest}>
      <Inner arrow={arrow}>{children}</Inner>
    </Link>
  );
};
